/**
 * Configuração de ambiente da aplicação
 */

interface AppConfig {
  apiBaseUrl: string
  apiTimeout: number
  appName: string
  appVersion: string
  isDevelopment: boolean
  isProduction: boolean
  enableDebug: boolean
  tenantId: string
  r2AssetsBucketFileStorage: string
}

// Configuração baseada no ambiente
const config: AppConfig = {
  // API base URL com prefixo /api/v1 conforme documentação da API
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
  apiTimeout: Number(import.meta.env.VITE_API_TIMEOUT) || 10000, // 10 segundos
  appName: import.meta.env.VITE_APP_NAME || 'FlowPilot',
  appVersion: import.meta.env.VITE_APP_VERSION || '1.0.0',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  enableDebug: import.meta.env.VITE_ENABLE_DEBUG === 'true' || import.meta.env.DEV,
  // Tenant ID configurável via environment ou padrão para dev
  tenantId: import.meta.env.VITE_TENANT_ID,
  r2AssetsBucketFileStorage: import.meta.env.VITE_R2_ASSETS_BUCKET_FILE_STORAGE
}

// Logs de configuração em desenvolvimento
if (config.isDevelopment && config.enableDebug) {
  console.group('🔧 App Configuration')
  console.log('API Base URL:', config.apiBaseUrl)
  console.log('Environment:', config.isDevelopment ? 'Development' : 'Production')
  console.log('Debug Mode:', config.enableDebug)
  console.groupEnd()
}

export default config